import { AgGridCustomFilterAdapter } from 'components/CustomTableFilter';
import type { ChapterEnum } from 'gql/graphql';

import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';

import { getWorkOrderChangeUerPriceList } from '../../WorkOrderChangeQueries';

interface IUseUerWorkOrderChangePriceListFilters {
    workOrderChangeObjectId?: number;
    chapter: ChapterEnum;
    changeFilterHandler: (params: { fieldName: string; checkedValues: string[] }) => void;
}

export const useUerWorkOrderChangePriceListFilters = (props: IUseUerWorkOrderChangePriceListFilters): ColDef[] => {
    const { workOrderChangeObjectId, chapter, changeFilterHandler } = props;

    const variables = useMemo(
        () => ({
            workOrderChangeObjectId,
            chapter,
        }),
        [chapter, workOrderChangeObjectId],
    );

    return useMemo(
        () => [
            {
                field: 'sectionName',
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: getWorkOrderChangeUerPriceList,
                    dataAccessor: 'uerWorkOrderChangePriceListUerQuery',
                    childFieldAccessor: 'sectionName',
                    whereVariables: ['sectionName'],
                    changeFilterHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Раздел',
                            field: 'sectionName',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
            {
                field: 'groupName',
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: getWorkOrderChangeUerPriceList,
                    dataAccessor: 'uerWorkOrderChangePriceListUerQuery',
                    childFieldAccessor: 'groupName',
                    whereVariables: ['groupName'],
                    changeFilterHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Подраздел',
                            field: 'groupName',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
            {
                field: 'code',
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: getWorkOrderChangeUerPriceList,
                    dataAccessor: 'uerWorkOrderChangePriceListUerQuery',
                    childFieldAccessor: 'code',
                    whereVariables: ['code'],
                    changeFilterHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Шифр',
                            field: 'code',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
            {
                field: 'name',
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables,
                    query: getWorkOrderChangeUerPriceList,
                    dataAccessor: 'uerWorkOrderChangePriceListUerQuery',
                    childFieldAccessor: 'name',
                    whereVariables: ['name'],
                    changeFilterHandler,
                    columns: [
                        {
                            checkboxSelection: true,
                            headerName: 'Наименование',
                            field: 'name',
                            lockVisible: true,
                            flex: 1,
                        },
                    ],
                },
            },
        ],
        [changeFilterHandler, variables],
    );
};
